import axios from 'axios';
import * as constants from '../constants/CONSTANT';
import { crmAuthHeaders } from './DataApi';

/**
 * BulkOwnerTransferApi
 *
 * Naming contract:
 * - bulkChangeOwnerRecords
 */
export async function bulkChangeOwnerRecords(objectName, ids, ownerid, options = {}) {
  const on = String(objectName || '').trim();
  if (!on) {
    throw new Error('objectName is required');
  }

  const url = `${constants.API_BASE_URL}/api/object/${on}/bulk-change-owner`;
  const payload = { ids, ownerid, options };

  return axios.patch(url, payload, {
    headers: {
      ...crmAuthHeaders(),
      'Content-Type': 'application/json',
    },
  });
}

